export const DETAILED_STATUS_POPUP_TEXT = 'detailedStatus'
